<div
  *ngIf="block"
  class="flex w-full"
  [ngClass]="{
    'justify-center': block.data.position === ButtonPosition.center,
    'justify-end': block.data.position === ButtonPosition.right,
    'justify-start': block.data.position === ButtonPosition.left || block.data.position === ButtonPosition.leftMobile100
  }"
>
  <pl-button
    [ngClass]="{
      '!w-fit': block.data.position !== ButtonPosition.leftMobile100,
      'md:!w-fit': block.data.position === ButtonPosition.leftMobile100
    }"
    [isDisabled]="isDisabled"
    [padding]="ButtonPadding.small"
    [variant]="buttonVariant"
    (click)="onButtonClick($event)"
  >
    {{ block.data.label }}
  </pl-button>
</div>
